// PHASE-2.01 START
import React from 'react';
export function Breadcrumb({ items }:{ items:{ label:string; href?:string }[] }){
  return (
    <nav aria-label="Breadcrumb" className="min-w-0 text-sm">
      <ol className="flex min-w-0 items-center gap-2 text-muted-foreground">
        {items.map((it,i)=> (
          <li key={i} className="inline-flex min-w-0 items-center gap-2">
            {it.href? <a href={it.href} className="truncate hover:text-foreground underline-offset-4 hover:underline">{it.label}</a> : <span aria-current="page" className="truncate text-foreground font-medium">{it.label}</span>}
            {i<items.length-1 && <span aria-hidden>›</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
// PHASE-2.01 END
